module.exports = __webpack_public_path__ + "img/bj_1.cf0d17ef.png";